export default __webpack_public_path__ + "static/media/register-bg.fa8146b2.svg";